module.exports = __webpack_public_path__ + "static/media/S1N1-5.10f41b69.svg";